import React, { useState, useEffect, useRef } from "react";
import { Link, withRouter, useLocation } from "react-router-dom";
import "./Navigation.css";

const Navigation = () => {
  const [isPastWorkOpen, setIsPastWorkOpen] = useState(false);
  const closeTimeoutRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    // Legacy support: We generally want to avoid the global jQuery call now 
    // since we are managing this locally.
    // window.activatePastWork(); 
  }, []);

  // ZEN LOGIC: Intent Timeout
  const handleMouseEnter = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    setIsPastWorkOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimeoutRef.current = setTimeout(() => {
      setIsPastWorkOpen(false);
    }, 300); // 300ms "Grace Period" for smooth transition
  };

  // Close menu when route changes (optional, but good UX)
  useEffect(() => {
    setIsPastWorkOpen(false);
  }, [location]);


  return (
    <div className="jcNavigation">
      <nav className="navbar navbar-expand-md navbar">
        <button
          className="navbar-toggler mr-auto custom-toggler"
          id="hamburger"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="nav navbar-nav mr-auto">
            <li className="mx-auto">
              <span className="sr-only">(current)</span>
              <Link
                to="/"
                className="nav-link closableNavLink"
                style={{ letterSpacing: "0" }}
              >
                <i className="fas fa-home"></i>
              </Link>
            </li>
            <div className="darkmode mx-auto">
              <div className="theme-switch">
                <div className="switch"></div>
              </div>
            </div>
          </ul>
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <Link
                className="nav-link closableNavLink btn btn-2"
                to="/headshots/"
                data-cont="Headshots"
              >
                Headshots
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="nav-link closableNavLink btn btn-2"
                to="/motion/"
              >
                Motion
              </Link>
            </li>


            {/* PAST WORK GROUP - ZEN HOVER REFACTOR */}
            <li
              className={`nav-item zen-group ${isPastWorkOpen ? 'open' : ''}`}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <a
                className={`nav-link btn btn-2 nav-toggle zen-trigger ${isPastWorkOpen ? 'open' : ''}`}
                style={{ cursor: "pointer" }}
              >
                More
                <i className={`las la-angle-right arrowright ${isPastWorkOpen ? 'open' : ''}`}></i>
              </a>

              {/* ABSOLUTE SUBMENU CONTAINER */}
              <div className={`zen-submenu ${isPastWorkOpen ? 'open' : ''}`}>
                <Link
                  className="nav-link closableNavLink btn btn-2"
                  to="/artwork/"
                >
                  Artwork
                </Link>
                <Link
                  className="nav-link closableNavLink btn btn-2"
                  to="/photography/"
                >
                  Photography
                </Link>
              </div>
            </li>


            <li className="nav-item">
              <Link
                className="nav-link closableNavLink btn btn-2"
                to="/contact/"
              >
                Contact
              </Link>
            </li>
          </ul>
          <ul className="nav navbar-nav ml-auto social">
            <li>
              <a
                href="http://imdb.me/jamescosmin"
                target={"_blank"}
                rel="noopener noreferrer"
                className="nav-link"
              >
                <i className="fab fa-imdb"></i>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/~cosmin/"
                target={"_blank"}
                rel="noopener noreferrer"
                className="nav-link"
              >
                <i className="fab fa-linkedin"></i>
              </a>
            </li>
            <li>
              <a
                href="https://x.com/JamesCosmin"
                target={"_blank"}
                rel="noopener noreferrer"
                className="nav-link"
              >
                <i className="fab fa-twitter-square"></i>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default withRouter(Navigation);